import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ZoneDeTravailAvecIlotDto} from '../dto/zone-de-travail-avec-ilot.dto';

@Injectable({
	providedIn: 'root'
})
export class IlotService {

	private urlIlots = '/ws/ilots';

	private http = inject(HttpClient);

	recupererIlotAvecBureauPreferentiel(bureauId: number): Observable<ZoneDeTravailAvecIlotDto> {
		const params = new HttpParams()
			.set('use-case', 'visualiser-bureau-preferentiel')
			.set('bureauId', bureauId);
		return this.http.get<ZoneDeTravailAvecIlotDto>(this.urlIlots, {params: params});
	}
}
